<template>
  <a-layout class="basic-layout">
    <a-layout-sider>
      <router-link class="logo" :to="{ name: $routeName.index }">物流后台管理系统</router-link>
      <a-menu
        theme="dark"
        mode="inline"
        :defaultOpenKeys="['orderAmmount', 'dayOrder'].includes($route.name) ? ['Root', 'Dashboard'] : openKeys"
        :selectedKeys="['orderAmmount', 'dayOrder'].includes($route.name) ? ['Root', 'Dashboard'] : selectedKeys"
      >
        <template v-for="menu in menus">
          <a-menu-item :key="menu.name" v-if="!menu.children || menu.children.length === 0">
            <router-link :to="{ name: menu.name }">{{ menu.meta.title }}</router-link>
          </a-menu-item>
          <a-sub-menu :key="menu.name" v-else>
            <span slot="title">
              {{ menu.meta.title }}
              <span v-if="menu.name == 'Order' && orderCount.order_new != 0" style="margin-left: 10px;">
                <a-badge :count="orderCount.order_new" />
              </span>
            </span>
            <a-menu-item :key="item.name" v-for="item in menu.children">
              <router-link :to="{ name: item.name }">
                {{ item.meta.title }}
                <span v-if="item.name == 'OrderList' && orderCount.order_new != 0" style="margin-left: 10px;">
                  <a-badge :count="orderCount.order_new" />
                </span>
              </router-link>
            </a-menu-item>
          </a-sub-menu>
        </template>
      </a-menu>
    </a-layout-sider>
    <a-layout>
      <a-layout-header class="layout-header">
        <main-header></main-header>
      </a-layout-header>
      <a-layout-content>
        <router-view />
      </a-layout-content>
      <a-layout-footer class="layout-footer">
        Copyright
        <a-icon type="copyright" />2020 物流后台管理系统
      </a-layout-footer>
    </a-layout>
  </a-layout>
</template>

<script>
import { mapGetters } from 'vuex';
import { mapState } from 'vuex';

import MainHeader from '@/components/layout/MainHeader';

export default {
  name: 'BasicLayout',

  components: {
    MainHeader,
  },

  data() {
    return {};
  },

  mounted() {
    this.$store.dispatch('order/loadOrderCount');
  },

  computed: {
    ...mapGetters('asyncRouter', ['menus']),
    ...mapState('order', ['orderCount']),

    selectedKeys() {
      return this.$route.matched.map(item => item.name);
    },

    openKeys() {
      return this.$route.matched.map(item => item.name);
    },
  },
};
</script>

<style scoped lang="less">
.basic-layout {
  min-height: 100%;
}

.logo {
  padding: 16px;
  display: block;
  color: #fff;
  font-size: 18px;
  font-weight: 500;
}

.layout-header {
  background-color: #fff;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
  position: relative;
  z-index: 9;
  padding: 0 12px;
}

.layout-footer {
  text-align: center;
  font-size: 14px;
  color: rgba(#000, 0.45);
}
</style>
